<template>
  <div class="banner">
    <div class="bottom_banner">
      <div class="bottom_box">
        <div
          class="list_box"
          v-for="(item, index) in list"
          :key="index"
          @click="submitDetails(item)"
        >
          {{ item.title }}
        </div>
      </div>

      <div class="bottom_box">
        <a href="https://beian.miit.gov.cn/" class="filing_txt">
          京ICP备2025102990号
        </a>
        <div>保际（北京）非物质文化遗产保护发展有限公司</div>
      </div>

      <!-- <div class="about_box">
        <div class="msg_content">
          <div class="msg_phone">联系电话：15562781987</div>
          <div>联系邮箱：Piichw@126.com</div>
        </div>
        <div class="msg_content">
          注册地址：北京市丰台区方庄南路18号院3号楼1层3—1内1109
        </div>
      </div> -->

      <div class="bottom_box" style="display: flex">
        <div class="msg_phone">联系电话：15562781987</div>
        <div>联系邮箱：Piichw@126.com</div>
      </div>

      <div class="bottom_box">
        注册地址：北京市丰台区方庄南路18号院3号楼1层3—1内1109
      </div>

      <div class="bottom_box">
        <a class="link_box" href="http://www.jowim.com/" target="_blank">
          技术支持：卓旻网络科技有限公司
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [
        {
          title: '网站地图',
        },
        {
          title: '关于我们',
          src: '/articleDetails',
          id: '1582e100d0cd491583ce6751bc813b56',
        },
        {
          title: '联系我们',
        },
        {
          title: '免责声明',
          src: '/articleDetails',
          id: 'b8b2ba671ceb4de9b8d8a621e2c71fd4',
        },
      ],
      linkList: [
        {
          title: '匠艺精神馆',
          src: 'https://www.cfm119.com/digitalmuseum/index.html',
        },
        // , {
        //     title: '国家文物局'
        // }, {
        //     title: '中国非物质文化遗产数字博物馆'
        // }
      ],
    }
  },
  methods: {
    submitDetails(item) {
      const currentRoute = this.$route.fullPath // Get the current route's full path
      const targetPath = `${item.src}?id=${item.id}` // Build the target path with query parameters

      // Check if the target path is different from the current route
      if (item.src && item.id && currentRoute !== targetPath) {
        this.$router.replace({
          path: item.src,
          query: {
            id: item.id,
          },
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.banner {
  padding: 40px 0;
  width: 100%;
  color: #fff;
  background: #333333;

  .bottom_banner {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-top: 30px;
    border-top: 1px solid #4c4c4c;

    .bottom_box {
      display: flex;
      justify-content: center;
      margin: 12px 0;
      width: 100%;

      .list_box {
        padding: 0 30px;
        cursor: pointer;
      }

      .filing_txt {
        color: #fff;
        padding-right: 50px;
      }

      .msg_phone {
        margin-right: 55px;
      }
    }

    // .about_box {
    //   display: flex;
    //   flex-direction: column;
    //   justify-content: center;
    //   align-items: center;

    //   .msg_content {
    //     display: flex;
    //     margin: 12px 0;

    //     .msg_phone {
    //       margin-right: 55px;
    //     }
    //   }
    // }

    .link_box {
      text-decoration: none;
      text-align: center;
      color: rgba(255, 255, 255, 0.3);
    }
  }
}
</style>
